// extracted by mini-css-extract-plugin
export default {"category_tab":"PatientCategoryTab_category_tab__m+3Iq","category_tab_selected":"PatientCategoryTab_category_tab_selected__bMJdt"};